// Author liang gang qiang
// Date 2023-09-08 12:20:26

import * as model from "@/model/sithMesII/pds/SithMomMaterialDrawingDownloadRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMomMaterialDrawingDownloadRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMESII_PDS_URL,
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'summaryModeVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'recordModeVo'
    })
    .buildStore()
